import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/OrganizationDefinitionResource.ts
var n = class n extends t {
	static {
		this.baseUrl = "/rest/organizations";
	}
	getDefinition() {
		return this.api.get(super.buildPath(`${n.baseUrl}/${this.api.organizationId}/definition`));
	}
	getOverrides() {
		return this.api.get(`${n.baseUrl}/${e.orgPlaceholder}/definition/overrides`);
	}
	updateOverrides(t) {
		return this.api.put(`${n.baseUrl}/${e.orgPlaceholder}/definition/overrides`, t);
	}
};
export { n as OrganizationDefinitionResource };

//# sourceMappingURL=OrganizationDefinitionResource.js.map